import {Theme} from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10, // A more modern, friendlier curve
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: theme.customShadows.z8
          },
          '&:active': {
            transform: 'translateY(0)',
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 48
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
            boxShadow: theme.customShadows.z8
          }
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: theme.customShadows.primary
          }
        },
        containedSecondary: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: theme.customShadows.secondary
          }
        },
        containedInfo: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: theme.customShadows.info
          }
        },
        containedSuccess: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: theme.customShadows.success
          }
        },
        containedWarning: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: theme.customShadows.warning
          }
        },
        containedError: {
          boxShadow: theme.customShadows.error
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  }
}
